# frozen_string_literal: true

module Engine
  module Game
    module G1871
    end
  end
end
